// @flow

import React, { Component } from 'react';
import { NavHashLink as NavLink } from 'react-router-hash-link';
import Menu from "../../Menu"
import './NewHomeHeader.scss';

export default class NewHomeHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menu: false,
      active: false
    };
  }

  showMenu(event) {
    console.log("showe menu", this.state.active);
    event.preventDefault();
    this.setState({
      active: true
    });
  }
  toggleMenu() {
    this.setState({
      active: !this.state.active
    });
  }

  closeMenu() {
    this.setState({
      active: false
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="new-home__header-container">
        <header>
          <div className="new-home__header  row">
            <div className="col-6 left-col">
              <img src="/img/tytan-logo.png"></img>

            </div>
            <div className="col-6 right-col">
              <span  onClick={this.showMenu.bind(this)} className="af-icon-menu"></span>
            </div>
          </div>  
        </header>
        <Menu
            menu={this.state.active}
            closeMenu={this.closeMenu.bind(this)}
            activeLink={this.props.activeLink}
          />
      </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NewHome/NewHomeHeader/NewHomeHeader.js